'use client';

import React, { useEffect, ReactNode } from 'react';

interface Props { children: ReactNode; }

export default function ScrollRevealProvider({ children }: Props) {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );

    const targets = document.querySelectorAll(
      '.reveal-up, .reveal-fade, .reveal-left, .reveal-right'
    );
    targets.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return <>{children}</>;
}